import { styled } from "@mui/material";
import Link from "next/link";

/**
 * - leading-trim: both;
 * - text-edge: cap;
 */
export const StyledLeadingTrimEdgeText = styled("p")`
  leading-trim: both;
  text-edge: cap;
`;

export const StyledLeadingTrimEdgeSpan = styled("span")`
  leading-trim: both;
  text-edge: cap;
`;

export const StyledLeadingTrimEdgeAnchor = styled(Link)`
  leading-trim: both;
  text-edge: cap;
`;
